<template>
  <div class="inquiry-list-view">
    <section class="toolbar-card">
      <div>
        <h2>询盘 Inquiries</h2>
        <p>查看官网联系表单提交的询盘并维护处理状态。</p>
      </div>
      <div class="toolbar-card__actions">
        <el-input
          v-model.trim="keyword"
          clearable
          placeholder="搜索姓名/邮箱 Search"
          size="small"
          @keyup.enter.native="handleFilterChange"
          @clear="handleFilterChange"
        />
        <el-select v-model="statusFilter" clearable placeholder="状态 Status" size="small" @change="handleFilterChange">
          <el-option label="新建 New" value="new" />
          <el-option label="处理中 Processing" value="processing" />
          <el-option label="已完成 Done" value="done" />
        </el-select>
        <el-button size="small" @click="handleFilterChange">查询 Search</el-button>
      </div>
    </section>

    <section class="table-card">
      <el-table :data="items" v-loading="loading" stripe>
        <el-table-column prop="createdAt" label="时间 Time" min-width="170">
          <template slot-scope="{ row }">{{ formatDate(row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="姓名 Name" min-width="160">
          <template slot-scope="{ row }">{{ [row.firstName, row.lastName].filter(Boolean).join(' ') || '-' }}</template>
        </el-table-column>
        <el-table-column prop="email" label="邮箱 Email" min-width="190" />
        <el-table-column prop="phone" label="电话 Phone" min-width="140" />
        <el-table-column prop="source" label="来源 Source" min-width="120" />
        <el-table-column prop="requestType" label="类型 Request" min-width="150" />
        <el-table-column prop="country" label="国家 Country" min-width="130" />
        <el-table-column label="状态 Status" min-width="170">
          <template slot-scope="{ row }">
            <el-select v-model="row.status" size="mini" @change="status => handleStatusChange(row, status)">
              <el-option label="新建 New" value="new" />
              <el-option label="处理中 Processing" value="processing" />
              <el-option label="已完成 Done" value="done" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="操作 Actions" min-width="110" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openDetail(row)">详情 Detail</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-bar">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :current-page="pagination.page"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50]"
          :total="pagination.total"
          @current-change="handlePageChange"
          @size-change="handlePageSizeChange"
        />
      </div>
    </section>

    <el-dialog title="询盘详情 Inquiry Detail" :visible.sync="detailVisible" width="680px">
      <div v-if="current" class="detail-grid">
        <p><strong>Name:</strong> {{ [current.firstName, current.lastName].filter(Boolean).join(' ') || '-' }}</p>
        <p><strong>Email:</strong> {{ current.email || '-' }}</p>
        <p><strong>Phone:</strong> {{ current.phone || '-' }}</p>
        <p><strong>Company:</strong> {{ current.company || '-' }}</p>
        <p><strong>Country:</strong> {{ current.country || '-' }}</p>
        <p><strong>ZIP:</strong> {{ current.zip || '-' }}</p>
        <p><strong>Customer:</strong> {{ current.customerType || '-' }}</p>
        <p><strong>Request:</strong> {{ current.requestType || '-' }}</p>
        <p class="detail-message"><strong>Message:</strong><br>{{ current.message || '-' }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fetchInquiries, updateInquiryStatus } from '../../api/inquiries'

export default {
  name: 'InquiryListView',
  data () {
    return {
      loading: false,
      keyword: '',
      statusFilter: '',
      items: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      detailVisible: false,
      current: null
    }
  },
  async created () {
    await this.loadData()
  },
  methods: {
    queryParams () {
      return {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
        keyword: this.keyword || undefined,
        status: this.statusFilter || undefined
      }
    },
    async loadData () {
      this.loading = true
      try {
        const { data } = await fetchInquiries(this.queryParams())
        this.items = Array.isArray(data) ? data : data.items
        this.pagination.total = Array.isArray(data) ? data.length : data.total
      } catch (error) {
        this.$message.error('询盘加载失败 Failed to load inquiries.')
      } finally {
        this.loading = false
      }
    },
    handleFilterChange () {
      this.pagination.page = 1
      this.loadData()
    },
    handlePageChange (page) {
      this.pagination.page = page
      this.loadData()
    },
    handlePageSizeChange (pageSize) {
      this.pagination.page = 1
      this.pagination.pageSize = pageSize
      this.loadData()
    },
    formatDate (value) {
      return value ? new Date(value).toLocaleString() : '-'
    },
    openDetail (row) {
      this.current = row
      this.detailVisible = true
    },
    async handleStatusChange (row, status) {
      try {
        await updateInquiryStatus(row.id, status)
        this.$message.success('状态已更新 Status updated.')
        await this.loadData()
      } catch (error) {
        this.$message.error('状态更新失败 Failed to update status.')
        await this.loadData()
      }
    }
  }
}
</script>

<style scoped>
.toolbar-card,
.table-card {
  border: 1px solid var(--line);
  border-radius: 12px;
  background: var(--panel);
  box-shadow: 0 16px 32px rgba(23, 20, 17, 0.04);
}

.toolbar-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 22px 24px;
}

.toolbar-card h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 500;
}

.toolbar-card p {
  margin: 8px 0 0;
  color: var(--muted);
}

.toolbar-card__actions {
  display: flex;
  gap: 10px;
}

.toolbar-card__actions .el-input,
.toolbar-card__actions .el-select {
  width: 190px;
}

.table-card {
  margin-top: 18px;
  padding: 12px;
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  padding: 14px 4px 2px;
}

.detail-grid {
  display: grid;
  gap: 10px;
}

.detail-grid p {
  margin: 0;
  line-height: 1.7;
}

.detail-message {
  white-space: pre-wrap;
}

@media (max-width: 960px) {
  .toolbar-card {
    flex-direction: column;
    align-items: flex-start;
  }

  .toolbar-card__actions {
    width: 100%;
    flex-wrap: wrap;
  }
}
</style>
